import { z } from "zod";

export const contactInterestOptions = [
	"general",
	"fractionalSupport",
	"agenticCommerce",
	"aiSeoRewriting",
	"other",
] as const;

export type ContactInterest = (typeof contactInterestOptions)[number];

export const contactFormSchema = z.object({
	email: z.string().email(),
	name: z.string().min(3),
	message: z.string().min(10),
	interest: z.enum(contactInterestOptions).optional(),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
